import {
    ReactElement,
} from 'react';

import {
    SimpleGrid,
    Table,
} from '@mantine/core';

import {useUsers} from '../hooks/useUsers';
import {useUsersFilter} from '../hooks/useUsersFilter';

import {
    RowSelectionDataCell,
    SimpleTableBatchAction,
    SimpleTablePagination,
    TableBody,
    TableBodyColumn,
    TableHeaderColumn,
    TableHeaderRow,
} from '@flexinet/ui-components';
import {useUsersSelection} from '../hooks/useUsersSelection';
import {IUserTableColumn,} from '../types';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {useUsersPaging} from "../hooks/useUsersPaging.ts";
import {useUsersSearch} from "../hooks/useUsersSearch.ts";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {filters} = useUsersFilter();

    const {
        columns,
        visibleItems,
        loading,
    } = useUsers(filters);

    const {
        limit,
        totalPages,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useUsersPaging();

    const {
        handleFilterByKeyword,
    } = useUsersSearch();

    const {
        selection,
        handleRowSelection,
        handleSelectAllRows,
    } = useUsersSelection();
    const getColumns = () => {
        let cols: IUserTableColumn[] = [];
        if (allowedActions.includes('DeleteUser')) {

            cols.push({
                          id: 'select',
                          title: '',
                          render: item => <RowSelectionDataCell
                              item={item}
                              handleChange={(item: any) => {
                                  const isCurrentlySelected = !!selection[item.id];
                                  const newCheckedState = !isCurrentlySelected;
                                  handleRowSelection(item.id, newCheckedState);
                              }}
                          />
                      },
            );
        }

        cols = cols.concat(columns);


        return cols;


    };


    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>
                <TableHeaderRow
                    columns={getColumns() as TableHeaderColumn[]}
                    handleSelectAllRows={() => {
                        const allSelected = visibleItems.every(item => selection[item.id]);
                        handleSelectAllRows(!allSelected, visibleItems);
                    }}
                />
                <TableBody
                    items={visibleItems}
                    loading={loading}
                    selection={selection as any}
                    columns={getColumns() as TableBodyColumn[]}
                />
            </Table>

            <SimpleTablePagination
                totalPages={totalPages}
                visibleCount={totalCount}
                handlePageChange={handlePageChange}
            />
        </SimpleGrid>
    );
};
